"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePlugins = void 0;
var _tsUtils = require("@ori/ts-utils");
var _react = require("react");
var _useAutoplay = require("./useAutoplay");
var _useKeyboard = require("./useKeyboard");
const usePlugins = (props, setIsTouchActive) => {
  const autoplay = (0, _useAutoplay.useAutoplay)(props, setIsTouchActive);
  const keyboard = (0, _useKeyboard.useKeyboard)(props);
  return (0, _react.useMemo)(() => [autoplay, keyboard].filter(_tsUtils.isNonNullable), [autoplay, keyboard]);
};
exports.usePlugins = usePlugins;
//# sourceMappingURL=usePlugins.js.map